module.exports = __webpack_public_path__ + "static/media/cbus-new.863650c0.png";